import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap";
import logolight from "../../assets/images/logo-light.png";
import logodark from "../../assets/images/logo-dark.png";

const VerifyOtp = () => {
  document.title = "Verify OTP | Onfon Group Legal";

  const navigate = useNavigate();
  const { email: userEmailFromParams } = useParams(); // Extract email/username from URL params
  const [message, setMessage] = useState(""); // OTP input
  const [userEmail, setUserEmail] = useState(""); // State to store user email
  const [errors, setErrors] = useState({}); // Validation errors
  const [apiError, setApiError] = useState(null); // API error messages

  // Validate OTP input
  const validateOtp = () => {
    let error = {};
    if (!message) {
      error.message = "Please Enter the OTP";
    } else if (!/^\d{6}$/.test(message)) {
      error.message = "OTP must be exactly 6 digits";
    }
    return error;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateOtp();

    if (Object.keys(validationErrors).length === 0) {
      try {
        if (!process.env.REACT_APP_API_BASE_URL) {
          throw new Error("API base URL is not defined");
        }

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/verifyOTP`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userEmail, message }),
        });

        const data = await response.json();

        if (response.ok) {
          // console.log({data})
          // Save the token to sessionStorage (or localStorage if needed)
          sessionStorage.setItem("authToken", data.token); // Store token in sessionStorage
          sessionStorage.setItem("authUser", JSON.stringify(data.user)); //Store user in sessionStorage
          // alert("OTP Verified Successfully!");
          navigate("/dashboard"); // Redirect to dashboard
        } else {
          setApiError("Invalid OTP. Please try again.");
        }
      } catch (error) {
        console.error("Error verifying OTP:", error);
        setApiError("An error occurred. Please try again.");
      }
    } else {
      setErrors(validationErrors);
    }
  };

  // Resend OTP functionality
  const handleResendOtp = async () => {
    try {
      if (!process.env.REACT_APP_API_BASE_URL) {
        throw new Error("API base URL is not defined");
      }
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/resendOTP`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userEmail }), // Pass user email for resend
      });
      const data = await response.json();
      if (data && data.success) {
        alert("OTP Resent Successfully!");
      } else {
        setApiError("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      setApiError("An error occurred while resending OTP.");
    }
  };

  useEffect(() => {
    document.body.className = "bg-pattern";

    // Check if user email exists in sessionStorage
    const storedUserEmail = sessionStorage.getItem("userEmail");
    // console.log({storedUserEmail});
    if (storedUserEmail) {
      setUserEmail(storedUserEmail); // Set user email from sessionStorage
    } else if (userEmailFromParams) {
      setUserEmail(userEmailFromParams); // Set user email from URL params
      sessionStorage.setItem("userEmail", userEmailFromParams); // Store in sessionStorage
    }

    return () => {
      document.body.className = "";
      // Optionally clear sessionStorage when the component unmounts
      // sessionStorage.removeItem("userEmail");
      // sessionStorage.removeItem("authToken");
    };
  }, [userEmailFromParams]);

  return (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div className="text-center">
                      <Link to="/">
                        <img
                          src={logodark}
                          alt="Onfon Group Logo"
                          height="24"
                          className="auth-logo logo-dark mx-auto"
                        />
                        <img
                          src={logolight}
                          alt="Onfon Group Logo"
                          height="24"
                          className="auth-logo logo-light mx-auto"
                        />
                      </Link>
                    </div>
                    <h4 className="font-size-18 text-muted mt-2 text-center">Verify OTP</h4>
                    <p className="mb-5 text-center">
                      Enter the 6-digit OTP sent to your phone
                    </p>
                    <Form className="form-horizontal" onSubmit={handleSubmit}>
                      {apiError && <div className="alert alert-danger">{apiError}</div>}
                      <Row>
                        <Col md={12}>
                          <div className="mb-4">
                            <Label className="form-label">OTP</Label>
                            <Input
                              name="otp"
                              className="form-control"
                              placeholder="Enter OTP"
                              type="text"
                              value={message}
                              onChange={(e) => {
                                setMessage(e.target.value);
                                setErrors({});
                                setApiError(null);
                              }}
                              invalid={!!errors.message}
                              aria-invalid={!!errors.message}
                              aria-label="Enter OTP"
                            />
                            {errors.message && (
                              <FormFeedback type="invalid">{errors.message}</FormFeedback>
                            )}
                          </div>
                          <div className="d-grid mt-4">
                            <button
                              className="btn btn-primary waves-effect waves-light"
                              type="submit"
                            >
                              Verify OTP
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p className="text-white-50">
                  Didn't receive the OTP?{" "}
                  <span
                    onClick={handleResendOtp}
                    className="fw-medium text-primary cursor-pointer"
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => e.key === "Enter" && handleResendOtp()}
                  >
                    Resend OTP
                  </span>
                </p>
                <p className="text-white-50">
                  © {new Date().getFullYear()} OnfonGroup. All rights reserved.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default VerifyOtp;